.wrapper {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content {
  max-width: calc(var(--page-max-width) * 4 / 7);
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.heading h1 {
  margin: 0;
  text-align: center;
  color: var(--color-text-dark);
  font-family: var(--font-family-heading);
  font-size: var(--font-size-3xl);
}

.heading p {
  font-size: var(--font-size-lg);
  margin-block: var(--space-2);
  text-align: center;
}

.socials {
  margin-top: var(--space-5);
}

.socials p {
  font-size: var(--font-size-lg);
  margin-block: var(--space-2);
  text-align: center;
  margin-bottom: var(--space-5);
}

.qrCodes {
  display: flex;
  justify-content: space-around;
}
